export default "__VITE_ASSET__CVeX0i2G__"